import { render, staticRenderFns } from "./list-commission.vue?vue&type=template&id=6a6dcc7c"
import script from "./list-commission.vue?vue&type=script&lang=js"
export * from "./list-commission.vue?vue&type=script&lang=js"
import style0 from "./list-commission.vue?vue&type=style&index=0&id=6a6dcc7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports